function jivo_onOpen() {
  document.getElementById("jivocb").style.display = "none";
}

function jivo_onClose() {
  document.getElementById("jivocb").style.display = "block";
}
